import { setLocalStorageValues, TableLocalStorageKey } from "../helpers"
import { useTableContext } from "../provider"

export const usePagination = () => {

  const ctx = useTableContext()
  const { tableId } = ctx.props

  const onPageChanged = (value) => {
    ctx.data.api.setPage(value)
    ctx.selection.api.reset()
  }

  const onPageSizeChanged = (value) => {
    ctx.muiGridApiRef?.current?.setPage?.(0)
    ctx.data.api.setPageSize(value)
    setLocalStorageValues(tableId, TableLocalStorageKey.pageSize, value)
  }

  return {
    onPageChanged,
    onPageSizeChanged,
  }
}
